module.exports = __webpack_public_path__ + "static/img/mataram.f95269b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UniLogo/mataram.png
// module id = AfXp
// module chunks = 18